module.exports = __webpack_public_path__ + "static/media/free.960dbe1f.png";